<div *ngIf="order" class="basket-main">
  <div class="basket-main-header d-none d-sm-block">
    <div class="row" >
      <div class="col">
        {{ 'Product' | translate }}
      </div>
      <div class="col-2 text-right">
        {{ 'Price' | translate }}
      </div>
      <div class="col-3 text-center">
        {{ 'Quantity' | translate }}
      </div>
      <div class="col-2 text-right">
        {{ 'Sum' | translate }}
      </div>
    </div>
  </div>
  <div *ngIf="order.orderLines.length" class="order-lines-multi">
    <div *ngFor="let date of dates" class='date-group container'>
      <p *ngIf="date" class="date-header">{{'Booking-basket-header' | translate: getGroupHeaderParams(date)}}
      </p>
      <hr *ngIf="date" class="mw-100" />
      <div *ngFor="let orderLine of getOrderLines(date)" class="basket-main-content basket-lines">
        <div class="row basket-line">
          <div class="col">
            <div *ngIf="canRemoveLine(orderLine)" (click)="reduceQuantityOrderLine(orderLine)" class="basket-delete-article">
              <div class="svg-container" [inlineSVG]="'assets/svg/icon/trash-solid.svg'"></div>
            </div>
            {{ orderLine.name | translate }}
          </div>
          <div class="col-3 col-sm-2 text-sm-right text-center">
            {{ toMoneyStr(orderLine.price) }}
          </div>
          <div *ngIf="!canChangeQuantity(orderLine)" class="col-3 text-center">
            {{ orderLine.quantity }}
          </div>
          <div class="col-12 d-block d-sm-none">
            <hr>
          </div>
          <div *ngIf="canChangeQuantity(orderLine)" class="col-12 col-sm-3 text-center">
            <div class="article-selector article-selector-basket align-self-center justify-content-center">
              <div>
                <app-count-button [faIcon]="faMinus" (singleClick)="onLineItemMinus(orderLine)" cssClass="fa edit-counter"></app-count-button>
                <span>{{ orderLine.quantity }}</span>
                <app-count-button [faIcon]="faPlus" (singleClick)="onLineItemAdd(orderLine)" cssClass="fa edit-counter"></app-count-button>
              </div>
            </div>
            <!-- <app-dropdown [items]="generateDropDownItems(maximumCount(orderLine))" [(ngModel)]="orderLine.quantityString"></app-dropdown> -->
          </div>
          <div class="col-2 text-right d-none d-sm-block">
            {{ toMoneyStr(orderLine.amount) }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="coupons && coupons.length > 0" class="basket-main-header">
    <div class="row">
      <div class="col-10">
        {{ 'Coupon' | translate }}
      </div>
      <div class="col-2 text-right">
        {{ 'Discount' | translate }}
      </div>
    </div>
  </div>
  <div *ngFor="let coupon of coupons" class="basket-main-content">
    <div class="row">
      <div class="col-10">
        {{ coupon.name }}
      </div>
      <div class="col-2 text-right">
        -{{ toMoneyStr(coupon.amount) }}
      </div>
    </div>
  </div>
  <div class="basket-main-footer">
    <div class="row">
      <div class="col-12 text-sm-right text-center">
        {{ 'Sum' | translate }}: {{ toMoneyStr(total) }}
      </div>
      <div class="col-12 text-sm-right basket-tax text-center">{{ 'incl VAT' | translate }}: {{ toMoneyStr(order.totalTax) }}</div>
    </div>
  </div>
</div>
